var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreerisckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8793 24.2196C24.2913 24.2196 29.4893 19.0216 29.4893 12.6095C29.4893 6.1975 24.2913 0.999512 17.8793 0.999512C11.4673 0.999512 6.26929 6.1975 6.26929 12.6095C6.26929 19.0216 11.4673 24.2196 17.8793 24.2196Z",
    stroke: "black",
    strokeWidth: 0.157156,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8793 24.2196C24.2913 24.2196 29.4893 19.0216 29.4893 12.6095C29.4893 6.1975 24.2913 0.999512 17.8793 0.999512C11.4673 0.999512 6.26929 6.1975 6.26929 12.6095C6.26929 19.0216 11.4673 24.2196 17.8793 24.2196Z",
    stroke: "#29ABE2",
    strokeWidth: 0.817211,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88861 27.7227H1V35.9997H5.88861V27.7227Z",
    stroke: "#F39200",
    strokeWidth: 0.785779,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82471 28.2271H9.32432L11.8242 25.8384H20.1568C22.0459 26.5697 22.7226 27.78 21.7122 29.7269H24.3232L31.2672 26.5051C31.2672 26.5051 32.8781 25.7273 33.767 26.6162C34.656 27.5052 34.8223 27.7826 34.8223 27.7826C35.564 29.3547 34.6332 30.3946 32.6003 31.4767C31.156 32.3379 25.3232 35.393 25.3232 35.393L5.82504 35.6153",
    stroke: "#F39200",
    strokeWidth: 0.785779,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0452 25.2827V28.6712",
    stroke: "#F39200",
    strokeWidth: 0.345743,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9336 27.3374V24.0601",
    stroke: "#F39200",
    strokeWidth: 0.345743,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9336 22.8394V21.8394",
    stroke: "#F39200",
    strokeWidth: 0.345743,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3128 19.4802C14.4531 19.2884 13.0905 17.6761 13.0135 15.2961H14.7215C14.8176 16.9274 15.7962 17.9449 17.9075 17.9449C19.8652 17.9449 20.9974 17.1771 20.9974 15.6419C20.9974 14.3369 20.2491 13.7608 18.7901 13.4539L16.8325 13.0319C14.7021 12.5713 13.4738 11.4581 13.4738 9.40441C13.4738 7.3507 14.8939 5.94965 17.3124 5.73879V4.16504H18.6174V5.7582C20.9395 6.00755 22.4942 7.54315 22.5136 9.71166H20.8057C20.7287 8.25305 19.7691 7.29347 17.8884 7.29347C16.2956 7.29347 15.2015 7.98428 15.2015 9.40475C15.2015 10.4985 15.8732 11.0746 17.2933 11.4006L19.1164 11.8229C21.4195 12.3605 22.7439 13.4352 22.7439 15.6422C22.7439 17.8492 21.1317 19.2502 18.6174 19.4614V21.0543H17.3124V19.4805H17.3128V19.4802Z",
    fill: "#F39200"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreerisckIcon);
export default __webpack_public_path__ + "static/media/freerisckIcon.b79ff2a236491a5fe26551887b7e9250.svg";
export { ForwardRef as ReactComponent };